import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { PageTitle } from 'presentation/components/PageTitle';
import FormSimulateSale from './components/FormSimulateSale';

type props = {
    simualteUseCase: SimulateUseCaseInterface;
};

const CU05301Page = ({ simualteUseCase }: props) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-053-01-container"
        >
            <PageTitle title="損益分岐シミュレーション" />
            <div className="content">
                <FormSimulateSale service={simualteUseCase} />
            </div>
        </div>
    );
};

export default CU05301Page;
